import SvgIconStyle from '@/components/SvgIconStyle';
import Iconify from '@/components/Iconify';
//
import { PATH_SETTINGS, ROOTS_SETTINGS } from '@/features/settings';
import { ROOTS_ROLES } from '@/features/roles-and-permissions';
import { ROOTS_USER_MANAGEMENT } from '@/features/users/dashboard-users';
import { ROOTS_AGENTDASHBOARD } from '@/features/agent-dashboard';
import {
  ROOTS_BOOKINGS_MANAGEMENT,
  bookingsManagementPath,
} from '@/features/bookings-management';
import {
  ROOTS_SERVICES_MANAGEMENT,
  PATH_SERVICES_MANAGEMENT,
} from '@/features/services-management';
import { ROOTS_PROVIDER_MANAGEMENT } from '@/features/users/providers';
import { ROOTS_COUPONS } from '@/features/coupons';
import { REFERRALS_ROOT } from '@/features/referrals';
import { ROOTS_IN_APP_POPUPS } from '@/features/in-app-popups';
import { ROOTS_CLIENT_MANAGEMENT } from '@/features/users/clients';
import { ROOTS_REVIEWS } from '@/features/reviews';
import { ROOTS_JOB_SCHEDULER } from '@/features/job-scheduler';
import { invoicesPath, ROOT_INVOICES } from '@/features/invoices';
import { ROOTS_TASKS } from '@/features/tasks';
import { ROOT_TRANSACTIONS } from '@/features/transactions';
import { ROOT_AUDIT_LOGS } from '@/features/audit-logs';
import { ROOT_SCHEDULED_JOBS } from '@/features/scheduled-jobs';

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: getIcon('ic_user'),
  audit: <Iconify icon={'eva:file-text-fill'} width={32} height={32} />,
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  agent_dashboard: <Iconify icon={'eva:grid-fill'} width={32} height={32} />,
  roles: <Iconify icon={'eva:lock-fill'} width={32} height={32} />,
  pots: <Iconify icon={'eva:stop-circle-fill'} width={32} height={32} />,
  settings: <Iconify icon={'eva:settings-fill'} width={32} height={32} />,
  products: <Iconify icon={'eva:cube-fill'} width={32} height={32} />,
  flow: <Iconify icon={'eva:phone-outline'} width={32} height={32} />,
  diary: <Iconify icon={'eva:calendar-fill'} width={32} height={32} />,
  coupons: <Iconify icon={'mdi:coupon'} width={32} height={32} />,
  marketing: <Iconify icon={'mdi:bullhorn'} width={32} height={32} />,
  popups: <Iconify icon={'mdi:message-badge'} width={32} height={32} />,
  bookings: <Iconify icon={'eva:book-open-outline'} width={32} height={32} />,
  reviews: (
    <Iconify icon={'eva:message-square-outline'} width={32} height={32} />
  ),
  services: <Iconify icon={'healthicons:clean-hands'} width={32} height={32} />,
  invoices: <Iconify icon={'eva:file-text-fill'} width={32} height={32} />,
  tasks: <Iconify icon={'eva:list-fill'} width={32} height={32} />,
  scheduledJobs: <Iconify icon={'eva:clock-fill'} width={32} height={32} />,
};

const settingsNavPath = (pathKey: string) =>
  `${ROOTS_SETTINGS}${PATH_SETTINGS[pathKey]}`;

const SETTINGS_NAV_CHILDREN = [
  {
    title: 'General',
    path: settingsNavPath('company'),
    children: [
      {
        title: 'Company',
        path: settingsNavPath('company'),
        restricted_to: ['settings.view'],
      },
      {
        title: 'Lead categories',
        path: settingsNavPath('leads'),
        restricted_to: ['settings.view'],
      },
    ],
  },
  {
    title: 'Products',
    path: settingsNavPath('providers'),
    children: [
      {
        title: 'Providers',
        path: settingsNavPath('providers'),
        restricted_to: ['settings.view'],
      },
      {
        title: 'Categories',
        path: settingsNavPath('categories'),
        restricted_to: ['settings.view'],
      },
      {
        title: 'Cover level types',
        path: settingsNavPath('coverLevel'),
        restricted_to: ['settings.view'],
      },
      {
        title: 'Cover extras',
        path: settingsNavPath('coverExtras'),
        restricted_to: ['settings.view'],
      },
    ],
  },
  {
    title: 'Platform prices',
    path: settingsNavPath('providerCityPrices'),
    children: [
      {
        title: 'Provider prices',
        path: settingsNavPath('providerCityPrices'),
        restricted_to: ['settings.view'],
      },
    ],
  },
  {
    title: 'Email',
    path: settingsNavPath('templates'),
    children: [
      {
        title: 'Email templates',
        path: settingsNavPath('templates'),
        restricted_to: ['settings.view'],
      },
    ],
  },
  {
    title: 'Chat',
    path: settingsNavPath('chatAccessGroups'),
    children: [
      {
        title: 'Chat access groups',
        path: settingsNavPath('chatAccessGroups'),
        restricted_to: ['chat_access_groups.view'],
      },
    ],
  },
];

const navConfig = [
  {
    subheader: '',
    restricted_to: [],
    items: [
      {
        title: 'Dahsboard',
        path: ROOTS_AGENTDASHBOARD,
        icon: ICONS.agent_dashboard,
        restricted_to: ['reports.view'],
      },
      {
        title: 'Tasks',
        path: ROOTS_TASKS,
        icon: ICONS.tasks,
        restricted_to: [],
      },
    ],
  },
  {
    subheader: 'management',
    restricted_to: [],
    items: [
      {
        title: 'Dashboard Users',
        path: ROOTS_USER_MANAGEMENT,
        icon: ICONS.user,
        restricted_to: ['users.view'],
      },
      {
        title: 'Providers',
        path: ROOTS_PROVIDER_MANAGEMENT,
        icon: ICONS.user,
        restricted_to: ['providers.view'],
      },
      {
        title: 'Clients',
        path: ROOTS_CLIENT_MANAGEMENT,
        icon: ICONS.user,
        restricted_to: ['clients.view'],
      },

      {
        title: 'bookings',
        path: ROOTS_BOOKINGS_MANAGEMENT,
        icon: ICONS.bookings,
        restricted_to: ['bookings.view'],
        children: [
          {
            title: 'Manage bookings',
            path: bookingsManagementPath('list'),
            restricted_to: ['bookings.view'],
          },
          {
            title: 'Manage sessions',
            path: bookingsManagementPath('sessionsList'),
            restricted_to: ['bookings.view'],
          },
        ],
      },

      {
        title: 'Job Scheduler',
        path: ROOTS_JOB_SCHEDULER,
        icon: ICONS.diary,
        restricted_to: ['job_scheduler.view'],
      },
      {
        title: 'services',
        path: ROOTS_SERVICES_MANAGEMENT,
        icon: ICONS.services,
        restricted_to: ['services.view'],
        children: [
          {
            title: 'Manage Services',
            path: `${PATH_SERVICES_MANAGEMENT.root}${PATH_SERVICES_MANAGEMENT.services}`,
            restricted_to: ['services.view'],
          },
          {
            title: 'Service Variants',
            path: `${PATH_SERVICES_MANAGEMENT.root}${PATH_SERVICES_MANAGEMENT.variants}`,
            restricted_to: ['services.view'],
          },
          {
            title: 'Blocked Dates',
            path: `${PATH_SERVICES_MANAGEMENT.root}${PATH_SERVICES_MANAGEMENT.blockedDates}`,
            restricted_to: ['services.view'],
          },
        ],
      },
      {
        title: 'invoices',
        path: ROOT_INVOICES,
        icon: ICONS.invoices,
        restricted_to: ['provider_invoices.view'],
        children: [
          {
            title: 'Cleaner Invoices',
            path: invoicesPath('list'),
            restricted_to: ['provider_invoices.view'],
          },
          {
            title: 'Invoice Dry Runs',
            path: invoicesPath('dryRuns'),
            restricted_to: ['provider_invoices.view'],
          },
        ],
      },
      {
        title: 'Marketing',
        path: ROOTS_COUPONS,
        icon: ICONS.marketing,
        restricted_to: [],
        children: [
          {
            title: 'Coupons',
            path: ROOTS_COUPONS,
            restricted_to: ['coupons.view'],
          },
          {
            title: 'Referrals / Rewards',
            path: REFERRALS_ROOT,
            restricted_to: ['referrals.view'],
          },
          {
            title: 'In-app Popups',
            path: ROOTS_IN_APP_POPUPS,
            restricted_to: ['settings.view'],
          },
        ],
      },
      {
        title: 'Reviews',
        path: ROOTS_REVIEWS,
        icon: ICONS.reviews,
        restricted_to: ['reviews.view'],
      },
      {
        title: 'Roles & Permissions',
        path: ROOTS_ROLES,
        icon: ICONS.roles,
        restricted_to: ['roles_permissions.view'],
      },
    ],
  },
  {
    subheader: 'Payments',
    restricted_to: [],
    items: [
      {
        title: 'Transactions',
        path: ROOT_TRANSACTIONS,
        icon: ICONS.audit,
        restricted_to: ['transactions.view'],
      },
    ],
  },
  {
    subheader: 'System',
    restricted_to: [],
    items: [
      {
        title: 'Audit Logs',
        path: ROOT_AUDIT_LOGS,
        icon: ICONS.audit,
        restricted_to: ['audit_logs.view'],
      },
      {
        title: 'Scheduled Jobs',
        path: ROOT_SCHEDULED_JOBS,
        icon: ICONS.scheduledJobs,
        restricted_to: ['settings.view'],
      },
      {
        title: 'Settings',
        path: ROOTS_SETTINGS,
        icon: ICONS.settings,
        restricted_to: [],
        children: SETTINGS_NAV_CHILDREN,
      },
    ],
  },
];

export default navConfig;
